import { useEffect } from 'react';
import { LayersControl, MapContainer, TileLayer, useMap, ZoomControl } from 'react-leaflet'
import BusLayer from '_components/layers/bus.layer';
import RouteLayer from '_components/layers/routes.layer';
import ErrorBoundary from '_components/error/ErrorBoundary';
import { MANUFACTURING_SITE as site }  from 'types/globals'; 

export { DatasBusMap };

/**
 * Cette fonction recentre la carte lorsque `location` change
 * @param {*} param0 
 * @returns 
 */
function RecenterMap({ location }) {
    const map = useMap();
    
    useEffect(() => {
        if (location) {
            map.setView(location, 12); // Recentrer la carte avec le zoom à 12
        }
    }, [location, map]); // La carte sera recentrée chaque fois que `location` ou `map` changent

    return null;
}

/**
 * Affiche le bus et le tracé des 15 dernières sur la carte 
 * uniquement lorsque des données sont disponibles
 * sinon centre sur le dépot d'Heuliez
 * @param {*} param0 
 * @returns 
 */
function DatasBusMap({bus, height}) {
    
    const location = (bus && bus.geometry && bus.geometry.coordinates && bus.geometry.coordinates.length > 0)
        ? [bus.geometry.coordinates[0][0], bus.geometry.coordinates[0][1]]
        : [site.coord.lat, site.coord.lng];
    const { BaseLayer } = LayersControl;
    const layers = require("../../../assets/files/layers.json");

    return (
        <ErrorBoundary>
            <MapContainer 
                center={location} 
                zoom={12} 
                zoomControl={false}
                className='w-full h-full'
                style={{ width: '100%', height: `${height}px` }}
                >
                <RecenterMap location={location} />
                <LayersControl>
                    {layers.map((e, index) =>
                    <BaseLayer key={index} checked={index === 0} name={e.name}>
                        <TileLayer
                            attribution={e.attribution}
                            url={e.url}
                            format={e.format}
                            style={e.style}
                        />
                    </BaseLayer>
                    )}
                </LayersControl>
                {bus && bus.geometry && bus.geometry.coordinates && bus.geometry.coordinates.length > 0 && 
                    <>
                        <BusLayer bus={bus}/>  
                        <RouteLayer route={bus} />
                    </>
                }                   
                <ZoomControl position="bottomright" />               
            </MapContainer>
        </ErrorBoundary>
    )
}
